import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from 'src/api/baseApi';
import authReducer from 'src/features/login/authSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export default rootReducer;
